import { Box, Grid } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next';

import TitleLink from '../../components/TitleLink'
import CustomCard from '../../components/CustomCard'
import { useDispatch } from 'react-redux';
import axios from 'axios';
import { BASE_URL } from '../../constants';
import ProgramCards from './ProgramCards';
import edu from '../../assets/images/edu.jpg';
import play from '../../assets/images/play.jpg';
import no_image from '../../assets/images/no_image.jpg';
import exercise from '../../assets/images/exercise.jpg';
import instruction from '../../assets/images/instruction.jpg';


function Programs() {
  const { t } = useTranslation('global');
  const [program, setProgram] = useState([]);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const redirectPageTo = (page) => {
    const path = `/${page}`;
    navigate(path);
  }

  useEffect(() => {
    axios.get(`${BASE_URL}/programs`, {
      headers: {
        "authorization": `${localStorage.getItem('token')}`,
        "Content-Type": "application/json",
      }
    }).then((res) => {
      setProgram(res.data)
    })
  }, []);

  const getThumnail = (type) => {
    switch (type) {
      case 'instruction':
        return instruction
      case 'questionnaire':
        return questionnaire
      case 'exercise':
        return exercise
      case 'education':
        return edu
      default:
        return no_image
    }
  }

  return (
    <div>

      <div className='full-container'>
        <TitleLink
          boxTitle={t('programs')}
          enableButton={false}
          enableLink={false}
        />
        <Grid container sx={{ display: 'flex', justifyContent: 'center' }}>
          {program && program.education &&
            // <CustomCard 
            //   headTitle={t('education')}
            //   handleCardClick={()=>redirectPageTo('educationList')}
            //   buttonTitle={t('view_all')}  
            //   image={program.education?.imageUrl}
            //   description={program.education?.text}
            // />   

            <ProgramCards title={t('education')} id={'education'} img={getThumnail('education')} data={program.education} desc={t('listOfAdio')} />

          }

          {program && program.exercise &&
            // <CustomCard 

            //   headTitle={t('exercise')}
            //   handleCardClick={()=>redirectPageTo('exerciseList')}
            //   buttonTitle={t('view_all')}  
            //   image={program.exercise?.imageUrl}
            //   description={program.exercise?.text}
            // />
            <ProgramCards title={t('exercise')} id={'exercise'} img={getThumnail('exercise')} data={program.exercise} desc={t('listOfVideo')} />
          }
          {program && program.instruction &&
            // <CustomCard 
            //   headTitle={t('instructions')}          
            //   handleCardClick={()=>redirectPageTo('instructionList')}
            //   buttonTitle={t('view_all')} 
            //   image={program.instruction?.imageUrl}
            //   description={program.instruction?.text}

            // />
            <ProgramCards title={t('instructions')} id={'instructions'} img={getThumnail('instruction')} data={[]} desc={t('instruction')} />
          }
        </Grid>

      </div>
    </div>
  )
}

export default Programs